import React, { useContext, useEffect, useMemo, useState } from "react";
import { AppContext } from "../context/AppContext";
import "bootstrap/dist/css/bootstrap.min.css";
import "jquery/dist/jquery.min.js";
//Datatable Modules

import $ from "jquery";
import { json, Link } from "react-router-dom";
import Form from "react-bootstrap/Form";
import Table from "react-bootstrap/Table";
import Nav from "react-bootstrap/Nav";
import Row from "react-bootstrap/Row";
import Tab from "react-bootstrap/Tab";

import ic_delete from "../assets/images/ic_delete.svg";
import ic_edit from "../assets/images/ic_edit.svg";
import ic_eyes from "../assets/images/ic_eyes.svg";
import Modal from "react-bootstrap/Modal";
import { ToastMsg } from "./TostMsg";
// import ApiConfig from "../api/ApiConfig";
import ApiConfig, { FILE_BASE_URL } from "../api/ApiConfig";
import {
  DeleteCallWithErrorResponse,
  multipartPostCallWithErrorResponse,
  multipartPutCallWithErrorResponse,
  PostCallWithAuthTokenWithErrorResponse,
  PostCallWithErrorResponse,
  putMultipartWithAuthCallWithErrorResponse,
  putMultipartWithAuthCallWithErrorResponsePlane,
  simpleGetCallWithErrorResponse,
} from "../api/ApiServices";
import { MDBRow, MDBCol } from "mdb-react-ui-kit";
import { Pagination } from "./Pagination";
import FormLoader from "./FormLoader";


// import {
//   DeleteCallWithErrorResponse,
//   multipartPostCallWithErrorResponse,

//   PostCallWithAuthTokenWithErrorResponse,
//   putMultipartWithAuthCallWithErrorResponse,
//   simpleGetCallWithErrorResponse,
// } from "../api/ApiServices";
import { Save, X, Upload, FileAudio, Loader2, CheckCircle, Plus, Pencil } from 'lucide-react';
import { Button } from "react-bootstrap";
import { useRef } from "react";


// --- Constants ---
const LANGUAGES = [
  { id: 'transliteration', label: 'Transliteration' },
  { id: 'english', label: 'English' },
  { id: 'hindi', label: 'Hindi' },
  { id: 'urdu', label: 'Urdu' },
  { id: 'gujarati', label: 'Gujarati' }
];


const INITIAL_LANG_STATE = {
  title: '', titleAudio: null,
  description: '', descriptionAudio: null,
  tarjama: '', tarjamaAudio: null,
  fazeelat: '', fazeelatAudio: null,
  reference: '',
  notes: '', notesAudio: null,
  arabicScript: '', arabicScriptAudio: null,
};

// Audio fields every language has: [formData key, API field suffix].
// The suffix is what dua-details returns and what dua-add / dua-update expect.
const LANG_AUDIO_FIELDS = [
  ['titleAudio', 'TitleAudio'],
  ['descriptionAudio', 'DescAudio'],
  ['tarjamaAudio', 'TarjamaAudio'],
  ['fazeelatAudio', 'FarzeelatAudio'],
  ['notesAudio', 'NotesAudio'],
  ['arabicScriptAudio', 'ArabicScriptAudio'],
];

// Snapshot of the audio paths currently saved on the server, keyed by API field name.
// An absent audio field means "keep the existing one" to the API, so without this
// snapshot an update cannot tell "untouched" apart from "removed by the admin".
const buildOriginalAudioMap = (data) => {
  const map = { arabicDuaAudio: data?.arabicDuaAudio || '' };
  LANGUAGES.forEach((lang) => {
    LANG_AUDIO_FIELDS.forEach(([, apiSuffix]) => {
      const apiKey = `${lang.id}${apiSuffix}`;
      map[apiKey] = data?.[apiKey] || '';
    });
  });
  return map;
};

const MAX_SURAH_ROWS = 20;
const makeLocalId = () => `row-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
const createSurahRow = (overrides = {}) => ({
  localId: makeLocalId(),
  text: '',
  audioFile: null,
  existingAudioPath: '',
  ...overrides,
});


// --- Sub-Component: FieldGroup ---
const FieldGroup = React.memo(({
  label,
  textValue,
  onTextChange,
  audioFile,
  onAudioChange,
  onAudioClear = null,
  inputType = 'text',
  rtl = false,
  fieldName
}) => {
  // inputKey resets the <input type="file"> after the user clears their pick
  const [inputKey, setInputKey] = React.useState(0);

  // audioFile can be a File object (new upload) or a URL string (existing saved audio)
  const isFileObject = audioFile instanceof File;
  const isUrlString = typeof audioFile === 'string' && audioFile.length > 0;

  // Manage blob URL in an effect so it is created once per File and properly revoked on change/unmount.
  // Calling URL.createObjectURL during render creates a new URL on every render and never revokes old ones.
  const [audioSrc, setAudioSrc] = React.useState(null);
  React.useEffect(() => {
    if (audioFile instanceof File) {
      const url = URL.createObjectURL(audioFile);
      setAudioSrc(url);
      return () => URL.revokeObjectURL(url);
    }
    if (typeof audioFile === 'string' && audioFile.length > 0) {
      setAudioSrc(`${FILE_BASE_URL}${audioFile}`);
      return;
    }
    setAudioSrc(null);
  }, [audioFile]);

  const handleClear = () => {
    if (onAudioClear) {
      onAudioClear();
      setInputKey(k => k + 1); // reset the file input
    }
  };

  return (
    <div className="card mb-4 border-light bg-light">
      <div className="card-body">
        <h6 className="card-title text-primary mb-3">{label}</h6>
        <div className="row g-3">
          {/* Text Input Column */}
          <div className="col-lg-7">
            <label className="form-label text-muted small" htmlFor={`text-${fieldName}`}>Text Content</label>
            {inputType === 'textarea' ? (
              <textarea
                id={`text-${fieldName}`}
                className="form-control"
                rows={4}
                value={textValue || ''}
                onChange={(e) => onTextChange(e.target.value)}
                dir={rtl ? 'rtl' : 'ltr'}
                placeholder={`Enter ${label}...`}
              />
            ) : (
              <input
                id={`text-${fieldName}`}
                type={inputType}
                className="form-control"
                value={textValue || ''}
                onChange={(e) => onTextChange(e.target.value)}
                dir={rtl ? 'rtl' : 'ltr'}
                placeholder={`Enter ${label}...`}
              />
            )}
          </div>


          {/* Audio Upload Column */}
          <div className="col-lg-5">
            <label className="form-label text-muted small" htmlFor={`file-${fieldName}`}>Audio File</label>
            <div className="input-group mb-2">
              <input
                key={inputKey}
                id={`file-${fieldName}`}
                type="file"
                className="form-control"
                accept="audio/*"
                onChange={(e) => onAudioChange(e.target.files[0])}
              />
              <span className="input-group-text"><Upload size={16} /></span>
            </div>

            {/* New upload: green banner — filename + Remove */}
            {isFileObject && (
              <div className="alert alert-success d-flex align-items-center p-2 mb-0 mt-2" style={{backgroundColor: '#e6f4ea', borderColor: '#ceead6'}}>
                <FileAudio size={18} className="me-2 text-success flex-shrink-0" />
                <div className="flex-grow-1 overflow-hidden">
                  <small className="d-block text-truncate text-success">New: {audioFile.name}</small>
                </div>
                {onAudioClear && (
                  <button
                    type="button"
                    className="btn btn-sm btn-link text-danger ms-2 p-0 flex-shrink-0"
                    onClick={handleClear}
                    title="Remove selected audio"
                  >
                    Remove
                  </button>
                )}
              </div>
            )}

            {/* Existing URL: blue banner — filename + Remove, then player */}
            {isUrlString && (
              <>
                {onAudioClear && (
                  <div className="alert alert-info d-flex align-items-center p-2 mb-0 mt-2">
                    <FileAudio size={18} className="me-2 text-info flex-shrink-0" />
                    <div className="flex-grow-1 overflow-hidden">
                      <small className="d-block text-truncate">Current: {audioFile.split('/').pop()}</small>
                    </div>
                    <button
                      type="button"
                      className="btn btn-sm btn-link text-danger ms-2 p-0 flex-shrink-0"
                      onClick={handleClear}
                      title="Remove audio"
                    >
                      Remove
                    </button>
                  </div>
                )}
                <div className="mt-2">
                  <audio controls className="w-100" style={{ height: '36px' }}>
                    <source src={`${FILE_BASE_URL}${audioFile}`} />
                    Your browser does not support the audio element.
                  </audio>
                </div>
              </>
            )}

            {/* Player for new File uploads */}
            {isFileObject && audioSrc && (
              <div className="mt-2">
                <audio key={audioSrc} controls className="w-100" style={{ height: '36px' }}>
                  <source src={audioSrc} />
                  Your browser does not support the audio element.
                </audio>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
});
// --- Sub-Component: SurahRow (Arabic Surah / Ayah multi-entry) ---
const SurahRow = React.memo(({
  row,
  index,
  onTextChange,
  onFileChange,
  onClearNewFile,
  onClearExisting,
  onRemove,
  readOnly = false,
}) => {
  const { text, audioFile, existingAudioPath } = row;
  const hasNewFile = audioFile instanceof File;
  const hasExisting = !hasNewFile && typeof existingAudioPath === 'string' && existingAudioPath.length > 0;

  // Same fix as FieldGroup: manage blob URL in an effect to avoid leaks and stale players.
  const [previewSrc, setPreviewSrc] = React.useState(null);
  React.useEffect(() => {
    if (audioFile instanceof File) {
      const url = URL.createObjectURL(audioFile);
      setPreviewSrc(url);
      return () => URL.revokeObjectURL(url);
    }
    const hasExistingAudio = typeof existingAudioPath === 'string' && existingAudioPath.length > 0;
    setPreviewSrc(hasExistingAudio ? `${FILE_BASE_URL}${existingAudioPath}` : null);
  }, [audioFile, existingAudioPath]);

  return (
    <div className="card mb-3 border-light bg-light">
      <div className="card-body">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h6 className="card-title text-primary mb-0">Arabic Surah / Ayah {index + 1}</h6>
          {!readOnly && (
            <button
              type="button"
              className="btn btn-sm btn-outline-danger"
              onClick={onRemove}
              title="Remove this surah"
            >
              <X size={14} />
            </button>
          )}
        </div>
        <div className="row g-3">
          <div className="col-lg-7">
            <label className="form-label text-muted small">Text Content</label>
            <textarea
              className="form-control"
              rows={3}
              value={text || ''}
              onChange={(e) => !readOnly && onTextChange(e.target.value)}
              dir="rtl"
              placeholder="Enter Arabic Surah / Ayah..."
              readOnly={readOnly}
            />
          </div>
          <div className="col-lg-5">
            {!readOnly && (
              <>
                <label className="form-label text-muted small">Audio File</label>
                <div className="input-group mb-2">
                  <input
                    type="file"
                    className="form-control"
                    accept="audio/*"
                    onChange={(e) => onFileChange(e.target.files[0])}
                  />
                  <span className="input-group-text"><Upload size={16} /></span>
                </div>
              </>
            )}

            {hasNewFile && (
              <div className="alert alert-success d-flex align-items-center p-2 mb-0 mt-2">
                <FileAudio size={18} className="me-2 text-success" />
                <div className="flex-grow-1 overflow-hidden">
                  <small className="d-block text-truncate text-success">New: {audioFile.name}</small>
                </div>
                {!readOnly && (
                  <button
                    type="button"
                    className="btn btn-sm btn-link text-danger ms-2 p-0"
                    onClick={onClearNewFile}
                    title="Undo new upload"
                  >
                    Undo
                  </button>
                )}
              </div>
            )}

            {hasExisting && (
              <div className="alert alert-info d-flex align-items-center p-2 mb-0 mt-2">
                <FileAudio size={18} className="me-2 text-info" />
                <div className="flex-grow-1 overflow-hidden">
                  <small className="d-block text-truncate">Current: {existingAudioPath.split('/').pop()}</small>
                </div>
                {!readOnly && (
                  <button
                    type="button"
                    className="btn btn-sm btn-link text-danger ms-2 p-0"
                    onClick={onClearExisting}
                    title="Remove current audio"
                  >
                    Remove
                  </button>
                )}
              </div>
            )}

            {previewSrc && (
              <div className="mt-2">
                <audio key={previewSrc} controls className="w-100" style={{ height: '36px' }}>
                  <source src={previewSrc} />
                </audio>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
});

function MultiSelectDua({ options, selectedIds, onChange }) {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const dropdownRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [dropdownRef]);

  const filteredOptions = useMemo(() => {
    return options.filter(opt =>
      opt.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [options, searchTerm]);

  const toggleDropdown = () => setIsOpen(!isOpen);

  const handleCheckboxChange = (id) => {
    if (selectedIds.includes(id)) {
      onChange(selectedIds.filter(itemId => itemId !== id));
    } else {
      onChange([...selectedIds, id]);
    }
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const visibleIds = filteredOptions.map(o => o.id);
      onChange([...new Set([...selectedIds, ...visibleIds])]);
    } else {
      const visibleIds = filteredOptions.map(o => o.id);
      onChange(selectedIds.filter(id => !visibleIds.includes(id)));
    }
  };

  const areAllVisibleSelected = filteredOptions.length > 0 && filteredOptions.every(opt => selectedIds.includes(opt.id));

  return (
    <div className="position-relative" ref={dropdownRef}>
      <button
        type="button"
        className="form-select text-start d-flex justify-content-between align-items-center"
        onClick={toggleDropdown}
      >
        <span className="text-truncate">
          {selectedIds.length === 0 ? "Select Duas..." : `${selectedIds.length} Duas Selected`}
        </span>
      </button>

      {isOpen && (
        <div className="card position-absolute w-100 shadow mt-1 border-primary" style={{ zIndex: 1050, maxHeight: '500px' }}>
          <div className="card-header bg-white p-2">
            <input
              type="text"
              className="form-control form-control-sm mb-2"
              placeholder="Search Duas..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              autoFocus
            />
            <div className="form-check border-bottom pb-2 mb-0">
              <input
                className="form-check-input"
                type="checkbox"
                id="selectAll"
                checked={areAllVisibleSelected}
                onChange={handleSelectAll}
                disabled={filteredOptions.length === 0}
              />
              <label className="form-check-label text-truncate w-100" htmlFor="selectAll" style={{ cursor: 'pointer' }}>
                {areAllVisibleSelected ? "Deselect All Visible" : "Select All Visible"}
              </label>
            </div>
          </div>

          <div className="card-body p-0 overflow-auto" style={{ maxHeight: '400px' }}>
            {filteredOptions.length === 0 ? (
              <div className="text-center p-3 text-muted small">No duas found.</div>
            ) : (
              <ul className="list-group list-group-flush">
                {filteredOptions.map(opt => (
                  <li key={opt.id} className="list-group-item list-group-item-action p-2">
                    <div className="form-check m-0">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id={`dua-${opt.id}`}
                        checked={selectedIds.includes(opt.id)}
                        onChange={() => handleCheckboxChange(opt.id)}
                      />
                      <label className="form-check-label w-100 text-truncate" htmlFor={`dua-${opt.id}`} style={{ cursor: 'pointer' }}>
                        {opt.name}
                      </label>
                    </div>
                  </li>
                ))}
              </ul>
            )}
          </div>

          <div className="card-footer bg-light p-1 text-center">
            <small className="text-primary fw-semibold" style={{ fontSize: '0.75rem' }}>
              {selectedIds.length} total selected
            </small>
          </div>
        </div>
      )}
    </div>
  );
}

const HifazatkiDua = () => {
  let module_id;
  let course_yr_id;
  let category_id;

  if (typeof window !== undefined) {
    module_id = localStorage.getItem("module_id");
    course_yr_id = localStorage.getItem("course_yr_id");
    category_id = localStorage.getItem("category_id");
  }

  const [imageWidth, setImageWidth] = useState({
    sabaqAudio: "100%",
    Uploade: "100%",
    Tarjama: "100%",
    Description: "100%",
  });

  const [add, setAdd] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [saveBotton, setSaveBotton] = useState(false);
  const [viewDetails, setViewDetails] = useState({});
  const [viewModal, setView] = useState(false);
  const handleViewClose = () => {
    setView(false);
  };
  const handleViewShow = () => setView(true);
   const [DuaList, setDuaList] = useState([]);
   const [folderList, setfolderList] = useState([]);
  const handleAddClose = (test) => {
    setAdd(false);
    setIdEdit(test);
    setAddSabaq({
      sabaqName: "",
      sabaqAudio: "",
      sabaqDesc: "",
      sabaqIcon: [],
      sabaqDescAudio: "",
      sabaqTeacherAudio: '',
      sabaqTeacherDesc: "",
      subSabaqs: [
        {
          subSabaqTitle: "",
          titleAudioPath: "",
          subSabaqDesc: "",
          descAudioPath: "",
          tarjama: "",
          tarjamaAudioPath: "",
          descReference: "",
          titleTeacherAudioPath: "",
          teacherDescAudioPath: "",
          teacherTarjamaAudioPath: "",
          mashqs: [
            {
              mashq: "",
              mashqAudioPath: "",
            },
          ],
        },
      ],
    });
  };

  // const [DuaList, setDuaaList] = useState([]);
  const [lasatSabaqId, setLsatSabaq] = useState("");
  // console.log("DATA",DuaList);

  const [nooraniQaaidaNumber, setNooraniQaaidaNumber] = useState();
  const [idEdit, setIdEdit] = useState("");
  const [SelectedDuaId, setSelectedDuaId] = useState(false);
  console.log("ISEDIT>>>>>>>", idEdit);

  console.log("NooraniQaaidaNumber", nooraniQaaidaNumber);
  const { sidebar, adminData, setEvent } = useContext(AppContext);
  const [loader, setLoader] = useState(true);

  const [show, setShow] = useState(false);
  // const handleClose = () => setShow(false);
  // const handleShow = () => setShow(true);

  const [Delete, setDelete] = useState(false);
  const [DeleteFolder, setDeleteFolder] = useState(false);
  const handleDeleteClose = () => setDelete(false);
  const handleDeleteShow = () => setDelete(true);  
  const handleDeleteCloseFolder = () => setDeleteFolder(false);
  const handleDeleteShowFolder = () => setDeleteFolder(true);

  const [sectionCatList, setsectionCatList] = useState([]);
  // const [activeCategory, setActiveCategory] = useState(
  //   localStorage.getItem("category_id") || "1"
  // );

  const [validated, setValidated] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);
  const [currentPageFolder, setCurrentPageFolder] = useState(0);
  const [viewData, setViewData] = useState(null);
  const [showViewModal, setShowViewModal] = useState(false);
  const [showViewModalFolder, setShowViewModalFolder] = useState(false);
  const startIndex = currentPage * 15;
  const endIndex = startIndex + 15;
  const startIndexFolder = currentPageFolder * 15;
  const endIndexFolder = startIndexFolder + 15;
  const changePage = ({ selected }) => {
    setCurrentPage(selected);
  };
  const changePageFolder = ({ selected }) => {
    setCurrentPageFolder(selected);
  };
  const pageCount = Math.ceil(DuaList?.length / 15);
  const pageCountFolder = Math.ceil(folderList?.length / 15);
  const handleSubmit = (event) => {
    const form = event.currentTarget;
    event.preventDefault();

    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      handleSubmitAddDua();
    }

    setValidated(true);
  };
const handleOpenView = (duaId) => {
  
  setLoader(true);
  simpleGetCallWithErrorResponse(ApiConfig.DETAILS_DUA + `${duaId}`)
    .then((res) => {
      setLoader(false);
      if (res.json && res.json.success === true) {
        const data = res.json.data;
        
        // Populate the shared formData state
        setFormData({
          orderNumber: data.orderNo || '',
          arabicDuaText: data.arabicDua || '',
          arabicDuaAudio: data.arabicDuaAudio || null,
          arabicSurahs: hydrateArabicSurahs(data.arabicSurahs),
          languages: LANGUAGES.reduce((acc, lang) => {
            acc[lang.id] = mapLangFields(data, lang.id);
            return acc;
          }, {})
        });
        setOriginalAudio(buildOriginalAudioMap(data));

        setShowViewModal(true); // Open the VIEW modal
      }
    });
};


  // const handleTabClick = (categoryID) => {
  //   console.log("ID>>>>>>>>>>>>>>>", categoryID);
  //   setActiveCategory(categoryID);
  //   // localStorage.setItem("category_id", categoryID);
  // };

  useEffect(() => {

    duaaListApi();
  }, []);

  const duaaListApi = (cateId) => {
    PostCallWithErrorResponse(
      ApiConfig.LIST_DUA
    )
      .then((res) => {
        setLoader(false);

        if (res.json && res.json?.success === true) {
          setDuaList(res.json.data);

          // setLsatSabaq(res.json?.data.allSabaq.length);
        } else {
          // ToastMsg("error", res.json.message);
        }
      })
      .catch((err) => {
        setLoader(false);

        // ToastMsg("error", "something went wrong");
      });
  };
    const folderListApi = (cateId) => {
    PostCallWithErrorResponse(
      ApiConfig.LIST_FOLDER
    )
      .then((res) => {
        setLoader(false);

        if (res.json && res.json?.success === true) {
          setfolderList(res.json.data);

          // setLsatSabaq(res.json?.data.allSabaq.length);
        } else {
          // ToastMsg("error", res.json.message);
        }
      })
      .catch((err) => {
        setLoader(false);

        // ToastMsg("error", "something went wrong");
      });
  };

  //  For new Crud
  const [addSabaq, setAddSabaq] = useState({
    sabaqName: "",                                                                           
    sabaqAudio: "",
    sabaqDesc: "",
    sabaqDescAudio: "",
    sabaqDescReference: "",
    sabaqIcon: [],
    sabaqTeacherAudio: '',
    sabaqTeacherDesc: "",
    subSabaqs: [
      {
        subSabaqTitle: "",
        descReference: "",
        tarjama: "",
        tarjamaAudioPath: "",
        titleAudioPath: "",
        subSabaqDesc: "",
        descAudioPath: "",
        titleTeacherAudioPath: "",
        teacherDescAudioPath: "",
        teacherTarjamaAudioPath: "",
        mashqs: [
          {
            mashq: "",
            mashqAudioPath: "",
          },
        ],
      },
    ],
  });
  console.log("addSabaqOBJ", addSabaq);

  const handleAddShow = (set) => {
    if (set === "add") {
      setIdEdit("");
      setAddSabaq({
        sabaqName: "",
        sabaqAudio: "",
        sabaqIcon: [],
        sabaqDescReference: "",
        sabaqDesc: "",
        sabaqDescAudio: "",
        subSabaqs: [
          {
            subSabaqTitle: "",
            descReference: "",
            tarjama: "",
            tarjamaAudioPath: "",
            titleAudioPath: "",
            subSabaqDesc: "",
            descAudioPath: "",
            mashqs: [
              {
                mashq: "",
                mashqAudioPath: "",
              },
            ],
          },
        ],
      });
    }
    setAdd(true);
  };

const handleSubmitAddDua = async (e) => {
  if (e) e.preventDefault();

  // Validation
  const translitTitleMissing = !formData.languages?.transliteration?.title?.trim();
  if (!formData.arabicDuaText || translitTitleMissing) {
    setErrors({
      arabicDuaText: !formData.arabicDuaText ? "Required" : null,
      transliterationTitle: translitTitleMissing ? "Transliteration Title is required" : null,
    });
    if (translitTitleMissing) setActiveTab('transliteration');
    return;
  }

  setIsSubmitting(true);
  const payLoadFormData = new FormData();

  // 1. Global Fields
  payLoadFormData.append("userId", parseInt(adminData?.user_id, 10) || 12);
  payLoadFormData.append("categoryId", parseInt(category_id, 10) || 1);
  payLoadFormData.append("orderNo", formData.orderNumber);
  payLoadFormData.append("arabicDua", formData.arabicDuaText);

  if (idEdit === "edit") {
    payLoadFormData.append("duaId", SelectedDuaId);
  }

  // Audios the admin cleared: something was saved, it was removed in the UI and no
  // replacement was picked. A field that is simply absent leaves the saved path in
  // place, so removals have to be stated explicitly.
  const removedAudioFields = [];

  // 2. Language & Audio Mapping
  LANGUAGES.forEach((lang) => {
    const data = formData.languages[lang.id];

    // Text
    payLoadFormData.append(`${lang.id}Title`, data.title || "");
    payLoadFormData.append(`${lang.id}Desc`, data.description || "");
    payLoadFormData.append(`${lang.id}Tarjama`, data.tarjama || "");
    payLoadFormData.append(`${lang.id}Farzeelat`, data.fazeelat || "");
    payLoadFormData.append(`${lang.id}Reference`, data.reference || "");
    payLoadFormData.append(`${lang.id}Notes`, data.notes || "");
    payLoadFormData.append(`${lang.id}ArabicScript`, data.arabicScript || "");

    // Audios: upload new File objects, flag cleared ones for removal.
    // A string value is an unchanged saved path and needs nothing sent.
    LANG_AUDIO_FIELDS.forEach(([stateKey, apiSuffix]) => {
      const apiKey = `${lang.id}${apiSuffix}`;
      const value = data[stateKey];
      if (value instanceof File) {
        payLoadFormData.append(apiKey, value);
      } else if (!value && originalAudio[apiKey]) {
        removedAudioFields.push(apiKey);
      }
    });
  });

  // Arabic Main Audio
  if (formData.arabicDuaAudio instanceof File) {
    payLoadFormData.append("arabicDuaAudio", formData.arabicDuaAudio);
  } else if (!formData.arabicDuaAudio && originalAudio.arabicDuaAudio) {
    removedAudioFields.push("arabicDuaAudio");
  }

  // Arabic Surahs (replace-all semantics on PUT).
  // Contiguous 0-based indices; fully-empty rows are skipped.
  let surahIndex = 0;
  (formData.arabicSurahs || []).forEach((row) => {
    const text = (row.text || '').trim();
    const hasNewFile = row.audioFile instanceof File;
    const hasExisting = !hasNewFile && typeof row.existingAudioPath === 'string' && row.existingAudioPath.length > 0;
    if (!text && !hasNewFile && !hasExisting) return;

    const i = surahIndex++;
    payLoadFormData.append(`arabicSurahText[${i}]`, row.text || '');
    if (hasNewFile) {
      payLoadFormData.append(`arabicSurahAudio[${i}]`, row.audioFile);
    } else if (hasExisting) {
      payLoadFormData.append(`arabicSurahExistingAudio[${i}]`, row.existingAudioPath);
    }
  });

  // Only meaningful on update — a new dua has nothing saved to remove.
  if (idEdit === "edit" && removedAudioFields.length > 0) {
    payLoadFormData.append("removedAudioFields", JSON.stringify(removedAudioFields));
  }

  const apiCall = idEdit === "edit"
    ? multipartPutCallWithErrorResponse(ApiConfig.UPDATE_DUA, payLoadFormData)
    : multipartPostCallWithErrorResponse(ApiConfig.ADD_DUA, payLoadFormData);

  apiCall
    .then((res) => {
      setIsSubmitting(false);
      if (res.json?.success) {
        ToastMsg("success", res.json.message);
        duaaListApi(category_id);
        setSelectedDuaId(""); // Keep track of the ID for the PUT request
      setIdEdit("");
        
        handleClose();
      } else {
        ToastMsg("error", res.json?.message);
      }
    })
    .catch(() => setIsSubmitting(false));
};
 


// 


const handleSubmitFolder = async (e) => {
  if (e) e.preventDefault();

  // 1. Validation
  if (!folderData.folder_name_english) {
    ToastMsg("error", "English Folder Name is required");
    return;
  }

  setIsSubmitting(true);

  // 2. Construct JSON Payload
  const payload = {
    userId: folderData.userId || 12,
    folder_name_english: folderData.folder_name_english,
    folder_name_hindi: folderData.folder_name_hindi,
    folder_name_urdu: folderData.folder_name_urdu,
    folder_name_gujarati: folderData.folder_name_gujarati,
    folder_name_transliteration: folderData.folder_name_transliteration,
    folder_name_arabi: folderData.folder_name_arabi,
    folder_desc_english: folderData.folder_desc_english,
    folder_desc_hindi: folderData.folder_desc_hindi,
    folder_desc_urdu: folderData.folder_desc_urdu,
    folder_desc_gujarati: folderData.folder_desc_gujarati,
    folder_desc_transliteration: folderData.folder_desc_transliteration,
    folder_desc_arabi: folderData.folder_desc_arabi,
    dua_ids: folderData.dua_ids, // Send as a real array [1, 2]
  };

  // 3. Add ID if Editing
  if (isEditMode) {
    payload.folder_id = SelectedDuaId;
  }

  // 4. API Call Dispatch 
  // Note: Using standard JSON call helpers instead of "multipart"
  const apiCall = isEditMode
    ? putMultipartWithAuthCallWithErrorResponsePlane(ApiConfig.UPDATE_FOLDER, JSON.stringify(payload)) // or putCall...
    : PostCallWithErrorResponse(ApiConfig.ADD_FOLDER,JSON.stringify(payload) );

  apiCall
    .then((res) => {
      setIsSubmitting(false);
      if (res.json?.success) {
        ToastMsg("success", res.json.message);
        
        folderListApi(category_id); 
        setShowModalFolder(false); 
        
        // Reset state
        setIdEdit("");
        setfolderData({
          userId: '',
          folder_name_english: '',
          folder_name_hindi: '',
          folder_name_urdu: '',
          folder_name_gujarati: '',
          folder_name_transliteration: '',
          folder_name_arabi: '',
          folder_desc_english: '',
          folder_desc_hindi: '',
          folder_desc_urdu: '',
          folder_desc_gujarati: '',
          folder_desc_transliteration: '',
          folder_desc_arabi: '',
          dua_ids: [],
          dua_names: []
        });
      } else {
        ToastMsg("error", res.json?.message || "Something went wrong");
      }
    })
    .catch((err) => {
      console.error("API Error:", err);
      setIsSubmitting(false);
      ToastMsg("error", "Server connection failed");
    });
};










const EditListApi = (id) => {
  setLoader(true);
  // Using the dynamic id passed to the function
  simpleGetCallWithErrorResponse(ApiConfig.DETAILS_DUA + `${id}`)
    .then((res) => {
      setLoader(false);

      if (res.json && res.json.success === true) {
        const data = res.json.data;

        // 1. Set the edit ID so the submit button knows it's an update
        setIdEdit("edit"); 
        setSelectedDuaId(data.duaId); // Keep track of the ID for the PUT request

        // 2. Map Flat API data to Nested formData state
        setFormData({
          orderNumber: data.orderNo || '',
          arabicDuaText: data.arabicDua || '',
          arabicDuaAudio: data.arabicDuaAudio || null, // Existing URL path
          arabicSurahs: hydrateArabicSurahs(data.arabicSurahs),
          languages: {
            english: mapLangFields(data, 'english'),
            hindi: mapLangFields(data, 'hindi'),
            transliteration: mapLangFields(data, 'transliteration'),
            urdu: mapLangFields(data, 'urdu'),
            gujarati: mapLangFields(data, 'gujarati'),
          }
        });
        setOriginalAudio(buildOriginalAudioMap(data));

        setShowModal(true);
      } else {
        ToastMsg("error", res.json.message);
      }
    })
    .catch((err) => {
      setLoader(false);
      console.error("Edit fetch error:", err);
    });
};

// Helper function to extract language-specific fields
const mapLangFields = (data, langPrefix) => {
  // Matches the API keys: e.g. englishTitle, englishDesc, englishFarzeelat
  return {
    title: data[`${langPrefix}Title`] || '',
    titleAudio: data[`${langPrefix}TitleAudio`] || null,
    description: data[`${langPrefix}Desc`] || '',
    descriptionAudio: data[`${langPrefix}DescAudio`] || null,
    tarjama: data[`${langPrefix}Tarjama`] || '',
    tarjamaAudio: data[`${langPrefix}TarjamaAudio`] || null,
    fazeelat: data[`${langPrefix}Farzeelat`] || '',
    fazeelatAudio: data[`${langPrefix}FarzeelatAudio`] || null,
    reference: data[`${langPrefix}Reference`] || '',
    notes: data[`${langPrefix}Notes`] || '',
    notesAudio: data[`${langPrefix}NotesAudio`] || null,
    arabicScript: data[`${langPrefix}ArabicScript`] || '',
    arabicScriptAudio: data[`${langPrefix}ArabicScriptAudio`] || null,
  };
};

// Map API arabicSurahs array into local row state.
const hydrateArabicSurahs = (apiSurahs) => {
  const list = Array.isArray(apiSurahs) ? apiSurahs : [];
  return list.map((s) => createSurahRow({
    text: s?.surahText || '',
    audioFile: null,
    existingAudioPath: s?.surahAudio || '',
  }));
};

  const viewDetailshandle = (id) => {
    // simpleGetCallWithErrorResponse(ApiConfig.EDIT + `?sabaqId=${id}`)
    simpleGetCallWithErrorResponse(
      ApiConfig.DETAILS_DUA + id
    )
      .then((res) => {
        setLoader(false);
        if (res.json && res.json?.success === true) {
          setViewDetails(res.json.data);
          handleViewShow();
          // ToastMsg("success", res.json.message);
        } else {
          ToastMsg("error", res.json.message);
        }
      })
      .catch((err) => {
        setLoader(false);

        // ToastMsg("error", "something went wrong");
      });
  };
 

const viewDetailshandleFolderEdit = (id) => {
  setLoader(true);
  simpleGetCallWithErrorResponse(ApiConfig.DETAILS_FOLDER + id)
    .then((res) => {
      setLoader(false);
      if (res.json && res.json.success === true) {
        const detail = res.json.folder_details[0]; // Get the first object from folder_details
        const duaIds = res.json.duas.map(d => d.dua_id);
        const duanames = res.json.duas.map(d => d.transliteration_title || d.dua_names || `Dua #${d.dua_id}`);

        // 1. Set the folder data for the form inputs
        setfolderData({
          userId: detail.folder_created_by,
          folder_name_english: detail.folder_name_english,
          folder_name_hindi: detail.folder_name_hindi,
          folder_name_urdu: detail.folder_name_urdu,
          folder_name_gujarati: detail.folder_name_gujarati,
          folder_name_transliteration: detail.folder_name_transliteration,
          folder_name_arabi: detail.folder_name_arabi,
          folder_desc_english: detail.folder_desc_english || '',
          folder_desc_hindi: detail.folder_desc_hindi || '',
          folder_desc_urdu: detail.folder_desc_urdu || '',
          folder_desc_gujarati: detail.folder_desc_gujarati || '',
          folder_desc_transliteration: detail.folder_desc_transliteration || '',
          folder_desc_arabi: detail.folder_desc_arabi || '',
          dua_ids: duaIds,
          dua_names: duanames
        });

        // 2. Set helper states for the Modal
        setSelectedDuaId(detail.folder_id); // Used for the UPDATE API call
        setIdEdit("edit");
        setIsEditMode(true); // Ensure your UI shows "Update" instead of "Create"
        setShowModalFolder(true); // Open the modal
      } else {
        ToastMsg("error", res.json.message);
      }
    })
    .catch((err) => {
      setLoader(false);
      console.error("View Details Error:", err);
      ToastMsg("error", "Something went wrong fetching details");
    });
};




const viewDetailshandleFolder = (id) => {
  setLoader(true);
  simpleGetCallWithErrorResponse(ApiConfig.DETAILS_FOLDER + id)
    .then((res) => {
      setLoader(false);
      if (res.json && res.json.success === true) {
        const detail = res.json.folder_details[0]; // Get the first object from folder_details
        const duaIds = res.json.duas.map(d => d.dua_id);
        const duanames = res.json.duas.map(d => d.transliteration_title || d.dua_names || `Dua #${d.dua_id}`);
        // 1. Set the folder data for the form inputs
        setfolderData({
          userId: detail.folder_created_by,
          folder_name_english: detail.folder_name_english,
          folder_name_hindi: detail.folder_name_hindi,
          folder_name_urdu: detail.folder_name_urdu,
          folder_name_gujarati: detail.folder_name_gujarati,
          folder_name_transliteration: detail.folder_name_transliteration,
          folder_name_arabi: detail.folder_name_arabi,
          folder_desc_english: detail.folder_desc_english || '',
          folder_desc_hindi: detail.folder_desc_hindi || '',
          folder_desc_urdu: detail.folder_desc_urdu || '',
          folder_desc_gujarati: detail.folder_desc_gujarati || '',
          folder_desc_transliteration: detail.folder_desc_transliteration || '',
          folder_desc_arabi: detail.folder_desc_arabi || '',
          dua_ids: duaIds,
          dua_names: duanames
        });

        // 2. Set helper states for the Modal
        setSelectedDuaId(detail.folder_id); // Used for the UPDATE API call
        setIdEdit("edit");
        setIsEditMode(true); // Ensure your UI shows "Update" instead of "Create"
        setShowViewModalFolder(true); // Open the modal
      } else {
        ToastMsg("error", res.json.message);
      }
    })
    .catch((err) => {
      setLoader(false);
      console.error("View Details Error:", err);
      ToastMsg("error", "Something went wrong fetching details");
    });
};

  const SabaqLisDeleteApi = () => {
    handleDeleteClose();
    const body = {
    
      duaId: deleteId,
    };
    // setIsLoading(true);
    DeleteCallWithErrorResponse(
      ApiConfig.DELETE_DUA,

      JSON.stringify({
        ...body,
      })
    )
      .then((res) => {
        setLoader(false);

        if (res.json && res.json?.success === true) {
          ToastMsg("success", res.json.message);

          // SabaqListApi();
          duaaListApi(category_id);
          setCurrentPage(0);

          // setIsDeleteList(true);
        } else {
          ToastMsg("error", res.json.message);
        }
      })
      .catch((err) => {
        setLoader(false);

        // ToastMsg("error", "something went wrong");
      });
  };


  const SabaqLisDeleteApiFolder = () => {
    handleDeleteClose();
    const body = {
    
      folder_id: deleteId,
    };
    // setIsLoading(true);
    DeleteCallWithErrorResponse(
      ApiConfig.DELETE_FOLDER,

      JSON.stringify({
        ...body,
      })
    )
      .then((res) => {
        setLoader(false);

        if (res.json && res.json?.success === true) {
          ToastMsg("success", res.json.message);

          // SabaqListApi();
          folderListApi(category_id);
          setCurrentPageFolder(0);

          // setIsDeleteList(true);
        } else {
          ToastMsg("error", res.json.message);
        }
      })
      .catch((err) => {
        setLoader(false);

        // ToastMsg("error", "something went wrong");
      });
  };




  // New Api code 
    const [showModal, setShowModal] = useState(false); // Controls the "Add Sabaq" modal
    const [showModalFolder, setShowModalFolder] = useState(false); // Controls the "Add Sabaq" modal
  
  
    // Form State
    const [activeTab, setActiveTab] = useState('transliteration');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [errors, setErrors] = useState({});
    const [submitStatus, setSubmitStatus] = useState(null);
 
    const [isEditMode, setIsEditMode] = useState(false);
    
  
  
    const [formData, setFormData] = useState({
      orderNumber: '',
      arabicDuaText: '',
      arabicDuaAudio: null,
      arabicSurahs: [createSurahRow()],
      languages: {
        english: { ...INITIAL_LANG_STATE },
        hindi: { ...INITIAL_LANG_STATE },
        transliteration: { ...INITIAL_LANG_STATE },
        urdu: { ...INITIAL_LANG_STATE },
        gujarati: { ...INITIAL_LANG_STATE },
      }
    });

    // Audio paths as they exist on the server for the dua being edited.
    const [originalAudio, setOriginalAudio] = useState({});

    const [folderData , setfolderData] = useState({
      userId: '',
      folder_name_english: '',
      folder_name_hindi:'',
      folder_name_urdu:'',
      folder_name_gujarati:'',
      folder_name_transliteration:'',
      folder_name_arabi:'',
      folder_desc_english: '',
      folder_desc_hindi: '',
      folder_desc_urdu: '',
      folder_desc_gujarati: '',
      folder_desc_transliteration: '',
      folder_desc_arabi: '',
      dua_ids:[],
      dua_names: []

    });
  console.log("folderdata>>>",folderData);
  
    // --- Handlers ---
    const handleShow = () => {
      setShowModal(true);
      setSubmitStatus(null);
    };
  
  
    const handleClose = () => {
        setShowModal(false);
        resetForm();
      
    };
  
  
    const resetForm = () => {
      setFormData({
          orderNumber: '',
          arabicDuaText: '',
          arabicDuaAudio: null,
          arabicSurahs: [createSurahRow()],
          languages: {
            english: { ...INITIAL_LANG_STATE },
            hindi: { ...INITIAL_LANG_STATE },
            transliteration: { ...INITIAL_LANG_STATE },
            urdu: { ...INITIAL_LANG_STATE },
            gujarati: { ...INITIAL_LANG_STATE },
          }
      });
      setOriginalAudio({});
      setErrors({});
      setSubmitStatus(null);
      setActiveTab('transliteration');
    };
  
  
    const handleGlobalChange = (e) => {
      const { name, value } = e.target;
      setFormData(prev => ({ ...prev, [name]: value }));
      if (errors[name]) setErrors(prev => ({ ...prev, [name]: null }));
    };
  
  
    const handleLangChange = (langId, field, value) => {
      setFormData(prev => ({
        ...prev,
        languages: {
          ...prev.languages,
          [langId]: { ...prev.languages[langId], [field]: value }
        }
      }));
    };
  
  
    const handleLangFileChange = (langId, field, file) => {
      if (file) {
        setFormData(prev => ({
          ...prev,
          languages: {
            ...prev.languages,
            [langId]: { ...prev.languages[langId], [field]: file }
          }
        }));
      }
    };

    // Clearing a freshly picked file falls back to the audio saved on the server;
    // clearing that saved audio marks the field for removal on save.
    const clearLangAudio = (langId, stateKey, apiSuffix) => {
      setFormData(prev => {
        const current = prev.languages[langId][stateKey];
        const next = current instanceof File ? (originalAudio[`${langId}${apiSuffix}`] || null) : null;
        return {
          ...prev,
          languages: {
            ...prev.languages,
            [langId]: { ...prev.languages[langId], [stateKey]: next }
          }
        };
      });
    };

    const clearArabicDuaAudio = () => {
      setFormData(prev => ({
        ...prev,
        arabicDuaAudio: prev.arabicDuaAudio instanceof File
          ? (originalAudio.arabicDuaAudio || null)
          : null,
      }));
    };

    const addArabicSurahRow = () => {
      setFormData(prev => {
        const current = prev.arabicSurahs || [];
        if (current.length >= MAX_SURAH_ROWS) return prev;
        return { ...prev, arabicSurahs: [...current, createSurahRow()] };
      });
    };

    const updateArabicSurahText = (index, text) => {
      setFormData(prev => ({
        ...prev,
        arabicSurahs: prev.arabicSurahs.map((r, i) => i === index ? { ...r, text } : r),
      }));
    };

    const setArabicSurahFile = (index, file) => {
      if (!file) return;
      setFormData(prev => ({
        ...prev,
        arabicSurahs: prev.arabicSurahs.map((r, i) => i === index ? { ...r, audioFile: file } : r),
      }));
    };

    const clearArabicSurahNewFile = (index) => {
      setFormData(prev => ({
        ...prev,
        arabicSurahs: prev.arabicSurahs.map((r, i) => i === index ? { ...r, audioFile: null } : r),
      }));
    };

    const clearArabicSurahExistingAudio = (index) => {
      setFormData(prev => ({
        ...prev,
        arabicSurahs: prev.arabicSurahs.map((r, i) => i === index ? { ...r, existingAudioPath: '' } : r),
      }));
    };

    const removeArabicSurahRow = (index) => {
      setFormData(prev => ({
        ...prev,
        arabicSurahs: prev.arabicSurahs.filter((_, i) => i !== index),
      }));
    };
  
  
    const validateForm = () => {
      const newErrors = {};
      if (!formData.arabicDuaText) newErrors.arabicDuaText = "Arabic Dua Text is required";
      if (!formData.languages?.transliteration?.title?.trim()) {
        newErrors.transliterationTitle = "Transliteration Title is required";
      }

      setErrors(newErrors);
      if (newErrors.transliterationTitle) setActiveTab('transliteration');
      return Object.keys(newErrors).length === 0;
    };
  
  
    const handleSubmitAI = async (e) => {
      e.preventDefault();
      setSubmitStatus(null);
     
      if (!validateForm()) {
        return;
      }
  
  
      setIsSubmitting(true);
  
  
      // Delegate to the real submit path so Enter-to-submit behaves the same
      // as clicking "Save Dua".
      try {
        await handleSubmitAddDua();
      } finally {
        setIsSubmitting(false);
      }
    };
     const handleInputChange = (field, value) => {
    setfolderData(prev => ({ ...prev, [field]: value }));
  };


  return (
    <main
      id="cx-main"
      className={sidebar ? "admin-main" : "cx-active admin-main"}
    >
      <div className="heading-btn-main">
        <div className="heading-common">
          <label htmlFor="">
            Hifazat ki Dua <span>(For All)</span>
          </label>
          <br />
        </div>
      </div>

      <Tab.Container id="left-tabs-example" defaultActiveKey="1">
        <Nav variant="pills" className="flex-row">

          <Nav.Item>
            <Nav.Link
              eventKey="1"
              onClick={() => {
                localStorage.setItem("category_id", 1);
              }}
            >
              Dua
            </Nav.Link>
          </Nav.Item>  
          <Nav.Item>
            <Nav.Link
              eventKey="5"
              onClick={() => {
                            localStorage.setItem("category_id", 13);
                            folderListApi(13);
                          }}
            >
              Folders
            </Nav.Link>
          </Nav.Item>
        </Nav>

        <Tab.Content>
          {/*   ====== Quran ===== */}
          <Tab.Pane eventKey="1">
            <div className="jobDescriptio-main">
              <div className="wrapper">
                <Tab.Container
                  id="left-tabs-example"
                  defaultActiveKey="1"
                // defaultActiveKey={activeCategory}
                >
                  <div className="row">
                 
                    <div className="">
                      {/* ==== Quraan ==== */}
                      <Tab.Content className="Syllabus_Custom_Tabs">
                        <Tab.Pane eventKey="1">
                            <div className="add-btn">
                                  <button onClick={() => {
                                    setIdEdit("");
                                    resetForm();
                                    setShowModal(true)}}>
                                    Add Dua
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      preserveAspectRatio="xMidYMid meet"
                                      viewBox="0 0 24 24"
                                    >
                                      <path
                                        fill="white"
                                        d="M11 19v-6H5v-2h6V5h2v6h6v2h-6v6Z"
                                      />
                                    </svg>
                                  </button>
                                </div>
                        <div className="table-wrapper">
            <h6>Total Records : {DuaList.length}</h6>
            <Table className="display" striped bordered hover size="lg">
              <thead className="text-center">
                <tr>
                  <th>Sr. No.</th>
                  <th
                  //  style={{ textAlign: "center" }}
                  >
                    Dua List
                  </th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                
                {DuaList && DuaList.length > 0
                  ? DuaList.slice(startIndex, endIndex).map((ele, index) => {
                    return (
                      <React.Fragment>
                        <tr key={"indexele" + index}>
                          <td style={{width:"100px"}}>{index + 1 + startIndex}</td>
                          <td style={{ textAlign: "left" }}>{ele.transliterationTitle}</td>
                          <td className="action">
                            <Link
                              to="#"
                              className="icon edit"
                              onClick={() => {
                                // handleAddShow();
                                setIdEdit("edit");
                                setImageWidth({
                                  ...imageWidth,
                                  sabaq: "117px",
                                  des: "117px",
                                  Title: "117px",
                                  subdesc: "117px",
                                  mashq: "117px",
                                });
                                setSelectedDuaId(ele.duaId)
                                EditListApi(ele.duaId);
                              }}
                            >
                              <img src={ic_edit} alt="" />
                            </Link>

                            <Link
                              to="#"
                              className="icon view"
                              // onClick={handleOpenView}
                              onClick={() => {
                           
                                // EditListApi(ele.sabaqId, "view");
                                // setViewDetails(viewSabaqList);
                                // setAddSabaq(filterEdit)
                                handleOpenView(ele.duaId);
                              }}
                            >
                              <img src={ic_eyes} alt="" />
                            </Link>

                            <Link
                              to="#"
                              className="icon delete"
                              onClick={() => {
                                handleDeleteShow();
                                setDeleteId(ele.duaId);
                              }}
                            >
                              <img src={ic_delete} alt="" />

                            </Link>
                          </td>
                        </tr>
                      </React.Fragment>
                    );
                  })
                  :  
                  <></>
                        }
              </tbody>
            </Table>

            {DuaList && DuaList.length > 0 ? (
              <Pagination
                changePage={changePage}
                pageCount={pageCount}
                currentPage={currentPage}
              />
            ) : (
              <div>
                <h5 style={{ color: "red", textAlign: "center" }}>
                  {" "}
                  Records Not Found
                </h5>
              </div>
            )}
          </div>
                        </Tab.Pane>
                          <Tab.Pane eventKey="2">
                          <div className="row jd-main">
                            <main id="cx-main" className="admin-main">
                              <div className="heading-btn-main">
                                <div className="heading-common"></div>
                                <div className="add-btn">
                                  <button onClick={() => showModalFolder("add")}>
                                    Add Folder
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      preserveAspectRatio="xMidYMid meet"
                                      viewBox="0 0 24 24"
                                    >
                                      <path
                                        fill="white"
                                        d="M11 19v-6H5v-2h6V5h2v6h6v2h-6v6Z"
                                      />
                                    </svg>
                                  </button>
                                </div>
                              </div>

                           
                            </main>
                          </div>
                        </Tab.Pane>
                      </Tab.Content>
                    </div>
                  </div>
                </Tab.Container>
              </div>
            </div>
          </Tab.Pane>
        
          {/* ============ Zaban ========== */}
          <Tab.Pane eventKey="5">
            <div className="jobDescriptio-main">
              <div className="wrapper">
                <Tab.Container id="left-tabs-example" defaultActiveKey="1">
                  <div className="row">
                    {/* <div className="">
                      <Nav variant="pills" className="flex-row">
                        <Nav.Item
                          onClick={() => {
                            localStorage.setItem("category_id", 13);
                            duaaListApi(13);
                          }}
                        >
                          <Nav.Link eventKey="1">Arabi</Nav.Link>
                        </Nav.Item>

                      </Nav>
                    </div> */}
                    <div className="">
                      <Tab.Content className="Syllabus_Custom_Tabs">
                        {/* ==== Zaban ==== */}

                        <Tab.Pane eventKey="1">
                          <div className="row jd-main">
                            <main id="cx-main" className="admin-main">
                              <div className="heading-btn-main">
                                <div className="heading-common"></div>
                                <div className="add-btn">
                                  <button onClick={() => {
                                   setIdEdit("");
                                   setIsEditMode(false);
                                     setfolderData({
          userId: '',
          folder_name_english: '',
          folder_name_hindi: '',
          folder_name_urdu: '',
          folder_name_gujarati: '',
          folder_name_transliteration: '',
          folder_name_arabi: '',
          folder_desc_english: '',
          folder_desc_hindi: '',
          folder_desc_urdu: '',
          folder_desc_gujarati: '',
          folder_desc_transliteration: '',
          folder_desc_arabi: '',
          dua_ids: [],
           dua_names: []
        });
                                    setShowModalFolder(true)}}
                                    
                                    >
                                    Add Folder
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      preserveAspectRatio="xMidYMid meet"
                                      viewBox="0 0 24 24"
                                    >
                                      <path
                                        fill="white"
                                        d="M11 19v-6H5v-2h6V5h2v6h6v2h-6v6Z"
                                      />
                                    </svg>
                                  </button>
                                </div>
                              </div>

                              {loader ? (
                                <FormLoader />
                              ) : (
                                <div className="table-wrapper">
                                  <h6>Total Records : {folderList.length}</h6>
                                  <Table
                                    className="display"
                                    striped
                                    bordered
                                    hover
                                    size="lg"
                                  >
                                    <thead className="text-center">
                                      <tr>
                                        <th>Sabaq No.</th>
                                        <th
                                        // style={{ textAlign: "left" }}
                                        >
                                          Folders List
                                        </th>
                                        <th>Action</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {folderList&& folderList.length > 0
                                        ? folderList
                                          .slice(startIndexFolder, endIndexFolder)
                                          .map((ele, index) => {
                                            return (
                                              <tr key={"duaaL" + index}>
                                                <td>
                                                  {index + 1 + startIndexFolder}
                                                </td>

                                                <td
                                                  style={{
                                                    textAlign: "left",
                                                  }}
                                                >
                                                  <div>{ele.folder_name_english}</div>
                                                  {ele.folder_desc_english && (
                                                    <small
                                                      className="text-muted d-block text-truncate"
                                                      style={{ maxWidth: '420px' }}
                                                      title={ele.folder_desc_english}
                                                    >
                                                      {ele.folder_desc_english}
                                                    </small>
                                                  )}
                                                </td>
                                                <td className="action">
                                                  <Link
                                                    to="#"
                                                    className="icon edit"
                                                    onClick={() => {
                                                      handleOpenView();
                                                      // setIdEdit("edit");
                                                      setImageWidth({
                                                        ...imageWidth,
                                                        sabaqAudio: "117px",
                                                        Uploade: "117px",
                                                        Tarjama: "117px",
                                                        Description: "117px",
                                                      });
                                                      viewDetailshandleFolderEdit(
                                                        ele.folder_id
                                                      );
                                                    }}
                                                  >
                                                    <img
                                                      src={ic_edit}
                                                      alt=""
                                                    />
                                                  </Link>
                                                  <Link
                                                    to="#"
                                                    className="icon view"
                                                    onClick={() =>
                                                      viewDetailshandleFolder(
                                                        ele.folder_id
                                                      )
                                                    }
                                                  >
                                                    <img
                                                      src={ic_eyes}
                                                      alt=""
                                                    />
                                                  </Link>
                                                  <Link
                                                    to="#"
                                                    className="icon delete"
                                                    onClick={() => {
                                                      handleDeleteShowFolder();
                                                      setDeleteId(
                                                        ele.folder_id
                                                      );
                                                    }}
                                                  >
                                                    <img
                                                      src={ic_delete}
                                                      alt=""
                                                    />
                                                  </Link>
                                                </td>
                                              </tr>
                                            );
                                          })
                                        : ""}
                                    </tbody>
                                  </Table>
                                  {folderList && folderList.length > 0 ? (
                                    <Pagination
                                      changePage={changePageFolder}
                                      pageCount={pageCountFolder}
                                      currentPage={currentPageFolder}
                                    />
                                  ) : (
                                    <div>
                                      <h5
                                        style={{
                                          color: "red",
                                          textAlign: "center",
                                        }}
                                      >
                                        {" "}
                                        Records Not Found
                                      </h5>
                                    </div>
                                  )}
                                </div>
                              )}
                            </main>
                          </div>
                        </Tab.Pane>
                        <Tab.Pane eventKey="2">
                          <div className="row jd-main">
                            <main id="cx-main" className="admin-main">
                              <div className="heading-btn-main">
                                <div className="heading-common"></div>
                                <div className="add-btn">
                                  <button onClick={() => handleAddShow("add")}>
                                    Add Dua
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      preserveAspectRatio="xMidYMid meet"
                                      viewBox="0 0 24 24"
                                    >
                                      <path
                                        fill="white"
                                        d="M11 19v-6H5v-2h6V5h2v6h6v2h-6v6Z"
                                      />
                                    </svg>
                                  </button>
                                </div>
                              </div>

                           
                            </main>
                          </div>
                        </Tab.Pane>
                      </Tab.Content>
                    </div>
                  </div>
                </Tab.Container>
              </div>
            </div>
          </Tab.Pane>
        </Tab.Content>
      </Tab.Container>
      {/* ======================= START ADD ========================== */}
  
      {/* ======================= END ADD ========================== */}

      {/* ======================= START DELETE ========================== */}
      <Modal
        show={Delete}
        onHide={handleDeleteClose}
        size="sm"
        aria-labelledby="contained-modal-subSabaqTitle-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="delete-msg text-center">
            <label htmlFor="">Are you sure you want to delete this item?</label>
          </div>
        </Modal.Body>
        <Modal.Footer className="justify-mashq-center">
          <div className="buttons-modal    ">
            <button
              className="me-2 bg-danger"
              onClick={() => {
                handleDeleteClose();
                SabaqLisDeleteApi();
              }}
            >
              Delete
            </button>
            <Link to="#" className="" onClick={handleDeleteClose}>
              Cancel
            </Link>
          </div>
        </Modal.Footer>
      </Modal> 


         <Modal
        show={DeleteFolder}
        onHide={handleDeleteCloseFolder}
        size="sm"
        aria-labelledby="contained-modal-subSabaqTitle-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="delete-msg text-center">
            <label htmlFor="">Are you sure you want to delete this item?</label>
          </div>
        </Modal.Body>
        <Modal.Footer className="justify-mashq-center">
          <div className="buttons-modal    ">
            <button
              className="me-2 bg-danger"
              onClick={() => {
                handleDeleteCloseFolder();
                SabaqLisDeleteApiFolder();
              }}
            >
              Delete
            </button>
            <Link to="#" className="" onClick={handleDeleteCloseFolder}>
              Cancel
            </Link>
          </div>
        </Modal.Footer>
      </Modal>
      {/* ======================= END DELETE ========================== */}

      {/* ======================= START VIEW ========================== */}

    

      {/* ======================= END VIEW ========================== */}

      {/* New Modal Ai  */} 
        <Modal
              show={showModal}
              onHide={() => {}}
              size="xl"
              centered
              backdrop="static"
              keyboard={false}
              scrollable={true}
            >
              <Modal.Header closeButton onHide={handleClose} className="bg-primary">
                <div className="d-flex align-items-center">
                  <div>
                      <Modal.Title className="bg-primary fw-bold text-white h5 mb-0">
                         {idEdit === "edit"
                ? "Update Dua"
                : "Add Duaa"}
                      </Modal.Title>
                  </div>
                </div>
              </Modal.Header>
             
              <Modal.Body className="bg-light p-4">
                  <Form noValidate onSubmit={handleSubmitAI}>
                     
                      {/* Status Messages */}
                      {submitStatus === 'success' && (
                      <div className="alert alert-success d-flex align-items-center mb-4 shadow-sm" role="alert">
                          <CheckCircle size={24} className="me-2" />
                          <div>Dua saved successfully! Ready for next entry.</div>
                      </div>
                      )}
                      {submitStatus === 'error' && (
                      <div className="alert alert-danger mb-4 shadow-sm" role="alert">
                          Something went wrong while saving. Please try again.
                      </div>
                      )}
      
      
                      {/* --- 1. GLOBAL SECTION CARD --- */}
                      <div className={`card shadow-sm mb-4 border-0 rounded-3 ${errors.arabicDuaText ? 'border border-danger' : ''}`}>
                          <div className="card-header card-header-custom py-3">
                              <h5 className="mb-0 text-dark">
                                  <span className="badge badge-deeniyat me-2 rounded-circle">1</span>
                                  Global Information
                              </h5>
                          </div>
                          <div className="card-body p-4">
                              <div className="row g-4 mb-4">
                                  <div className="col-md-12">
                                      <label className="form-label fw-bold">Order Number</label>
                                      <input
                                          type="number"
                                          className={`form-control form-control-lg ${errors.orderNumber ? 'is-invalid' : ''}`}
                                          name="orderNumber"
                                          value={formData.orderNumber}
                                          onChange={handleGlobalChange}
                                          placeholder="e.g. 10"
                                      />
                                      {errors.orderNumber && <div className="invalid-feedback">{errors.orderNumber}</div>}
                                  </div>
                              </div>
      
      
                              <hr className="my-4 text-muted opacity-25" />
      
      
                              {/* Arabic Dua */}
                              <div className="mb-4">
                                  {errors.arabicDuaText && <div className="text-danger small mb-1 fw-bold">{errors.arabicDuaText}</div>}
                                  <FieldGroup
                                      label="Arabic Dua (Main)"
                                      fieldName="arabicDua"
                                      textValue={formData.arabicDuaText}
                                      onTextChange={(val) => {
                                          setFormData(prev => ({ ...prev, arabicDuaText: val }));
                                          if (val && errors.arabicDuaText) setErrors(prev => ({...prev, arabicDuaText: null}));
                                      }}
                                      audioFile={formData.arabicDuaAudio}
                                      onAudioChange={(file) => setFormData(prev => ({ ...prev, arabicDuaAudio: file }))}
                                      onAudioClear={clearArabicDuaAudio}
                                      inputType="textarea"
                                      rtl={true}
                                  />
                              </div>
      
      
                              {/* Arabic Surahs / Ayah (multi-entry) */}
                              <div className="mb-2">
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                  <h6 className="mb-0 text-muted">Arabic Surah / Ayah</h6>
                                  <small className="text-muted">
                                    {(formData.arabicSurahs || []).length} / {MAX_SURAH_ROWS}
                                  </small>
                                </div>

                                {(formData.arabicSurahs || []).length === 0 && (
                                  <div className="text-muted small mb-2">
                                    No Surah / Ayah entries. Click "Add Another" to add one.
                                  </div>
                                )}

                                {(formData.arabicSurahs || []).map((row, index) => (
                                  <SurahRow
                                    key={row.localId}
                                    row={row}
                                    index={index}
                                    onTextChange={(val) => updateArabicSurahText(index, val)}
                                    onFileChange={(file) => setArabicSurahFile(index, file)}
                                    onClearNewFile={() => clearArabicSurahNewFile(index)}
                                    onClearExisting={() => clearArabicSurahExistingAudio(index)}
                                    onRemove={() => removeArabicSurahRow(index)}
                                  />
                                ))}
                              </div>

                              <button
                                  type="button"
                                  className="btn btn-primary w-100 py-3 fw-bold mt-3 d-flex align-items-center justify-content-center"
                                  onClick={addArabicSurahRow}
                                  disabled={(formData.arabicSurahs || []).length >= MAX_SURAH_ROWS}
                              >
                                  <Plus size={18} className="me-2" /> Add Another Surah / Ayah
                              </button>
                          </div>
                      </div>
      
      
                      {/* --- 2. MULTI-LANGUAGE SECTION CARD --- */}
                      <div className="card shadow-sm border-0 rounded-3">
                          <div className="card-header card-header-custom py-3">
                              <h5 className="mb-0 text-dark">
                                  <span className="badge badge-deeniyat me-2 rounded-circle">2</span>
                                  Language Details
                              </h5>
                          </div>
                          <div className="card-body p-0">
                              {/* Tabs Navigation */}
                              <ul className="nav nav-tabs nav-fill bg-light px-3 pt-3 border-bottom-0">
                                  {LANGUAGES.map((lang) => (
                                      <li className="nav-item" key={lang.id}>
                                          <button
                                              type="button"
                                              className={`nav-link py-3 ${activeTab === lang.id ? 'active' : ''}`}
                                              onClick={() => setActiveTab(lang.id)}
                                          >
                                              {lang.label}
                                          </button>
                                      </li>
                                  ))}
                              </ul>
 
                              {/* Tabs Content */}
                              <div className="p-4 border-top">
                                  {LANGUAGES.map((lang) => {
                                      if (activeTab !== lang.id) return null;
                                      const currentData = formData.languages[lang.id];
                                      const isRtl = lang.id === 'urdu';

                                      return (
                                          <div key={lang.id} className="fade show active">
                                              <div className="alert border-0 mb-4" style={{ backgroundColor: '#e6f4ea', color: '#747b26' }}>
                                                  <strong>Editing:</strong> {lang.label} Content
                                              </div>


                                              {lang.id === 'transliteration' && errors.transliterationTitle && (
                                                  <div className="text-danger small mb-1 fw-bold">{errors.transliterationTitle}</div>
                                              )}
                                              <FieldGroup
                                                  label={`${lang.label} Title`}
                                                  fieldName={`${lang.id}-title`}
                                                  textValue={currentData.title}
                                                  onTextChange={(val) => {
                                                      handleLangChange(lang.id, 'title', val);
                                                      if (lang.id === 'transliteration' && val && errors.transliterationTitle) {
                                                          setErrors(prev => ({ ...prev, transliterationTitle: null }));
                                                      }
                                                  }}
                                                  audioFile={currentData.titleAudio}
                                                  onAudioChange={(file) => handleLangFileChange(lang.id, 'titleAudio', file)}
                                                  onAudioClear={() => clearLangAudio(lang.id, 'titleAudio', 'TitleAudio')}
                                                  inputType="text"
                                                  rtl={isRtl}
                                              />


                                              <FieldGroup
                                                  label={`${lang.label} Description`}
                                                  fieldName={`${lang.id}-description`}
                                                  textValue={currentData.description}
                                                  onTextChange={(val) => handleLangChange(lang.id, 'description', val)}
                                                  audioFile={currentData.descriptionAudio}
                                                  onAudioChange={(file) => handleLangFileChange(lang.id, 'descriptionAudio', file)}
                                                  onAudioClear={() => clearLangAudio(lang.id, 'descriptionAudio', 'DescAudio')}
                                                  inputType="text"
                                                  rtl={isRtl}
                                              />


                                              <FieldGroup
                                                  label={`${lang.label} Tarjama (Translation)`}
                                                  fieldName={`${lang.id}-tarjama`}
                                                  textValue={currentData.tarjama}
                                                  onTextChange={(val) => handleLangChange(lang.id, 'tarjama', val)}
                                                  audioFile={currentData.tarjamaAudio}
                                                  onAudioChange={(file) => handleLangFileChange(lang.id, 'tarjamaAudio', file)}
                                                  onAudioClear={() => clearLangAudio(lang.id, 'tarjamaAudio', 'TarjamaAudio')}
                                                  inputType="textarea"
                                                  rtl={isRtl}
                                              />


                                              <FieldGroup
                                                  label={`${lang.label} Fazeelat (Virtues)`}
                                                  fieldName={`${lang.id}-fazeelat`}
                                                  textValue={currentData.fazeelat}
                                                  onTextChange={(val) => handleLangChange(lang.id, 'fazeelat', val)}
                                                  audioFile={currentData.fazeelatAudio}
                                                  onAudioChange={(file) => handleLangFileChange(lang.id, 'fazeelatAudio', file)}
                                                  onAudioClear={() => clearLangAudio(lang.id, 'fazeelatAudio', 'FarzeelatAudio')}
                                                  inputType="textarea"
                                                  rtl={isRtl}
                                              />

                                              <div className="card mb-4 border-light bg-light">
                                                  <div className="card-body">
                                                      <h6 className="card-title text-primary mb-3">{`${lang.label} Reference (Hawala)`}</h6>
                                                      <input
                                                          type="text"
                                                          className="form-control"
                                                          value={currentData.reference || ''}
                                                          onChange={(e) => handleLangChange(lang.id, 'reference', e.target.value)}
                                                          placeholder={`Enter ${lang.label} Reference (Hawala)...`}
                                                          dir={isRtl ? 'rtl' : 'ltr'}
                                                      />
                                                  </div>
                                              </div>

                                              <FieldGroup
                                                  label={`${lang.label} Notes`}
                                                  fieldName={`${lang.id}-notes`}
                                                  textValue={currentData.notes}
                                                  onTextChange={(val) => handleLangChange(lang.id, 'notes', val)}
                                                  audioFile={currentData.notesAudio}
                                                  onAudioChange={(file) => handleLangFileChange(lang.id, 'notesAudio', file)}
                                                  onAudioClear={() => clearLangAudio(lang.id, 'notesAudio', 'NotesAudio')}
                                                  inputType="textarea"
                                                  rtl={isRtl}
                                              />

                                              <FieldGroup
                                                  label={`${lang.label} Arabic Dua Script`}
                                                  fieldName={`${lang.id}-arabicScript`}
                                                  textValue={currentData.arabicScript}
                                                  onTextChange={(val) => handleLangChange(lang.id, 'arabicScript', val)}
                                                  audioFile={currentData.arabicScriptAudio}
                                                  onAudioChange={(file) => handleLangFileChange(lang.id, 'arabicScriptAudio', file)}
                                                  onAudioClear={() => clearLangAudio(lang.id, 'arabicScriptAudio', 'ArabicScriptAudio')}
                                                  inputType="textarea"
                                                  rtl={isRtl}
                                              />
                                          </div>
                                      );
                                  })}
                              </div>
                          </div>
                      </div>
                  </Form>
              </Modal.Body>
              <Modal.Footer className="bg-white border-top">
                  <Button
                      variant="outline-secondary"
                      onClick={handleClose}
                      disabled={isSubmitting}
                      className="d-flex align-items-center"
                  > Cancel
                  </Button>
                  <Button
                      variant="primary"
                      onClick={handleSubmit} // Trigger form submission
                      disabled={isSubmitting}
                      className="d-flex align-items-center px-4"
                  >
                      {isSubmitting ? (
                          <>
                              <Loader2 size={18} className="me-2 animate-spin" /> Saving...
                          </>
                      ) : (
                          <>
                              <Save size={18} className="me-2" /> Save Dua
                          </>
                      )}
                  </Button>
              </Modal.Footer>
            </Modal> 
              {showModalFolder && (
        <>
          <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-lg modal-dialog-scrollable">
              <div className="modal-content border-0 shadow">
                <div className="modal-header bg-primary text-white">
                  <h5 className="modal-title fw-bold">
                    {isEditMode ? <><i className="fas fa-edit me-2"></i> Edit Folder</> : <><i className="fas fa-folder-plus me-2"></i> Create New Folder</>}
                  </h5>
                  <button type="button" className="btn-close btn-close-white" onClick={() => setShowModalFolder(false)}></button>
                </div>
                <div className="modal-body">
                  <form>
                    {/* Multilingual Inputs Grid */}
                    <div className="row g-3">
                      {/* English */}
                      <div className="col-md-6">
                        <label className="form-label fw-semibold">Folder Name (English) <span className="text-danger">*</span></label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="e.g. Morning Adhkar"
                          value={folderData.folder_name_english}
                          onChange={(e) => handleInputChange('folder_name_english', e.target.value)}
                        />
                        <label className="form-label fw-semibold mt-2">Folder Description (English)</label>
                        <textarea
                          className="form-control"
                          rows={3}
                          placeholder="Optional description for this folder"
                          value={folderData.folder_desc_english || ''}
                          onChange={(e) => handleInputChange('folder_desc_english', e.target.value)}
                        />
                      </div>


                      {/* Hindi */}
                      <div className="col-md-6">
                        <label className="form-label fw-semibold">Folder Name (Hindi)</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="e.g. सुबह के अज़कार"
                          value={folderData.folder_name_hindi}
                          onChange={(e) => handleInputChange('folder_name_hindi', e.target.value)}
                        />
                        <label className="form-label fw-semibold mt-2">Folder Description (Hindi)</label>
                        <textarea
                          className="form-control"
                          rows={3}
                          placeholder="वैकल्पिक विवरण"
                          value={folderData.folder_desc_hindi || ''}
                          onChange={(e) => handleInputChange('folder_desc_hindi', e.target.value)}
                        />
                      </div>


                      {/* Transliteration */}
                      <div className="col-6">
                        <label className="form-label fw-semibold">Folder Name (Transliteration)</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="e.g. Subah ke Azkar"
                          value={folderData.folder_name_transliteration}
                          onChange={(e) => handleInputChange('folder_name_transliteration', e.target.value)}
                        />
                        <label className="form-label fw-semibold mt-2">Folder Description (Transliteration)</label>
                        <textarea
                          className="form-control"
                          rows={3}
                          placeholder="Optional description (transliteration)"
                          value={folderData.folder_desc_transliteration || ''}
                          onChange={(e) => handleInputChange('folder_desc_transliteration', e.target.value)}
                        />
                      </div>
                         <div className="col-6">
                        <label className="form-label fw-semibold">Folder Name (Arabic)</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="e.g. Subah ke Azkar"
                          value={folderData.folder_name_arabi}
                          onChange={(e) => handleInputChange('folder_name_arabi', e.target.value)}
                        />
                        <label className="form-label fw-semibold mt-2">Folder Description (Arabic)</label>
                        <textarea
                          className="form-control text-end"
                          dir="rtl"
                          rows={3}
                          placeholder="وصف اختياري"
                          value={folderData.folder_desc_arabi || ''}
                          onChange={(e) => handleInputChange('folder_desc_arabi', e.target.value)}
                          style={{ fontFamily: 'Tahoma, Arial' }}
                        />
                      </div>


                      {/* Urdu (RTL) */}
                      <div className="col-md-6">
                        <label className="form-label fw-semibold d-flex justify-content-between">
                          Folder Name (Urdu)
                          {/* <span className="badge bg-secondary">RTL</span> */}
                        </label>
                        <input
                          type="text"
                          className="form-control text-end"
                          dir="rtl"
                          placeholder="e.g. صبح کے اذکار"
                          value={folderData.folder_name_urdu}
                          onChange={(e) => handleInputChange('folder_name_urdu', e.target.value)}
                          style={{ fontFamily: 'Tahoma, Arial' }}
                        />
                        <label className="form-label fw-semibold mt-2">Folder Description (Urdu)</label>
                        <textarea
                          className="form-control text-end"
                          dir="rtl"
                          rows={3}
                          placeholder="اختیاری تفصیل"
                          value={folderData.folder_desc_urdu || ''}
                          onChange={(e) => handleInputChange('folder_desc_urdu', e.target.value)}
                          style={{ fontFamily: 'Tahoma, Arial' }}
                        />
                      </div>


                      {/* Gujarati */}
                      <div className="col-md-6">
                        <label className="form-label fw-semibold">Folder Name (Gujarati)</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="e.g. સવારના અઝકાર"
                          value={folderData.folder_name_gujarati}
                          onChange={(e) => handleInputChange('folder_name_gujarati', e.target.value)}
                        />
                        <label className="form-label fw-semibold mt-2">Folder Description (Gujarati)</label>
                        <textarea
                          className="form-control"
                          rows={3}
                          placeholder="વૈકલ્પિક વર્ણન"
                          value={folderData.folder_desc_gujarati || ''}
                          onChange={(e) => handleInputChange('folder_desc_gujarati', e.target.value)}
                        />
                      </div>
                    </div>


                    {/* <hr className="my-4" /> */}


                    {/* Dua Multi-Select Section */}
                    <div className="mb-3 mt-3">
                      <label className="form-label fw-semibold mb-2">Assign Duas to Folder</label>
                      <MultiSelectDua
                        options={DuaList.map(d => ({ id: d.duaId, name: d.transliterationTitle || d.englishTitle || `Dua #${d.duaId}` }))}
                        selectedIds={folderData.dua_ids}
                        onChange={(ids) => {
                          const selectedDuas = DuaList.filter(dua => ids.includes(dua.duaId));
                          setfolderData(prev => ({
                            ...prev,
                            dua_ids: ids,
                            dua_names: selectedDuas.map(dua => dua.transliterationTitle || dua.englishTitle || `Dua #${dua.duaId}`)
                          }));
                        }}
                      />
                    </div>
                  </form>
                </div>
                <div className="modal-footer bg-light">
                  <button type="button" className="btn btn-secondary" onClick={() => setShowModalFolder(false)}>Cancel</button>
                 <button 
  type="button" 
  className="btn btn-primary px-4" 
  onClick={handleSubmitFolder} 
  disabled={isSubmitting}
>
  {isSubmitting ? 'Processing...' : (isEditMode ? 'Update Folder' : 'Create Folder')}
</button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {/* View Form  */}
      {/* View Modal */}
      {showViewModal && (
  <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.7)', zIndex: 1050 }}>
    <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
      <div className="modal-content border-0 shadow-lg">
        {/* Header */}
        <div className="modal-header bg-primary text-white py-3">
          <h5 className="modal-title fw-bold d-flex align-items-center">
            <i className="fas fa- eye me-2"></i> Dua Details View
          </h5>
          <button type="button" className="btn-close btn-close-white" onClick={() => setShowViewModal(false)}></button>
        </div>

        {/* Body */}
        <div className="modal-body p-4 bg-light">
          {/* Section 1: Global & Arabic */}
          <div className="card border-0 shadow-sm mb-4">
            <div className="card-body">
              <div className="row mb-4">
                <div className="col-md-12">
                  <label className="text-muted small text-uppercase fw-bold">Order No</label>
                  <div className="fw-bold fs-5 text-primary">{formData.orderNumber || 'N/A'}</div>
                </div>
              </div>

              <div className="p-3 rounded bg-white border-start border-4 border-primary mb-3">
                <label className="text-muted small text-uppercase fw-bold d-block mb-2">Arabic Dua</label>
                <div className="fs-3 text-end font-arabic" style={{ direction: 'rtl', lineHeight: '1.8' }}>
                  {formData.arabicDuaText}
                </div>
                {formData.arabicDuaAudio && (
                  <audio controls className="w-100 mt-2" style={{ height: '36px' }}>
                    <source src={`${FILE_BASE_URL}${formData.arabicDuaAudio}`} />
                  </audio>
                )}
              </div>

              {(formData.arabicSurahs || []).length > 0 ? (
                <div className="mt-3">
                  <label className="text-muted small text-uppercase fw-bold d-block mb-2">
                    Surahs / Ayah <span className="text-muted">({(formData.arabicSurahs || []).length})</span>
                  </label>
                  {(formData.arabicSurahs || []).map((row, idx) => (
                    <div key={row.localId || idx} className="p-3 rounded bg-white border-start border-4 border-info mb-2">
                      <div className="d-flex justify-content-between align-items-center mb-1">
                        <span className="badge bg-light text-dark border">#{idx + 1}</span>
                      </div>
                      {row.text ? (
                        <div className="fs-5 text-end font-arabic" style={{ direction: 'rtl', lineHeight: '1.7' }}>
                          {row.text}
                        </div>
                      ) : (
                        <div className="text-muted small fst-italic">(no text)</div>
                      )}
                      {row.existingAudioPath && (
                        <audio controls className="w-100 mt-2" style={{ height: '36px' }}>
                          <source src={`${FILE_BASE_URL}${row.existingAudioPath}`} />
                        </audio>
                      )}
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-muted small fst-italic mt-2">No Surah / Ayah entries.</div>
              )}
            </div>
          </div>

          {/* Section 2: Multi-Language Details */}
          <div className="row g-3">
            {LANGUAGES.map((lang) => {
              const langData = formData.languages[lang.id];
              return (
                <div className="col-md-6" key={lang.id}>
                  <div className="card h-100 border-0 shadow-sm">
                    <div className="card-header bg-white border-bottom py-2 fw-bold text-primary">
                      {lang.label} Content
                    </div>
                    <div className="card-body">
                      <div className="mb-2">
                        <span className="small text-muted fw-bold">Title:</span>
                        <div className="text-dark">{langData.title || '—'}</div>
                        {langData.titleAudio && (
                          <audio controls className="w-100 mt-1" style={{ height: '32px' }}>
                            <source src={`${FILE_BASE_URL}${langData.titleAudio}`} />
                          </audio>
                        )}
                      </div>
                      <div className="mb-2">
                        <span className="small text-muted fw-bold">Description:</span>
                        <div className="text-dark small">{langData.description || '—'}</div>
                        {langData.descriptionAudio && (
                          <audio controls className="w-100 mt-1" style={{ height: '32px' }}>
                            <source src={`${FILE_BASE_URL}${langData.descriptionAudio}`} />
                          </audio>
                        )}
                      </div>
                      <div className="mb-2">
                        <span className="small text-muted fw-bold">Translation:</span>
                        <div className="text-dark border-top mt-1 pt-1 italic">{langData.tarjama || '—'}</div>
                        {langData.tarjamaAudio && (
                          <audio controls className="w-100 mt-1" style={{ height: '32px' }}>
                            <source src={`${FILE_BASE_URL}${langData.tarjamaAudio}`} />
                          </audio>
                        )}
                      </div>
                      <div className="mb-2">
                        <span className="small text-muted fw-bold">Virtues:</span>
                        <div className="text-success small">{langData.fazeelat || '—'}</div>
                        {langData.fazeelatAudio && (
                          <audio controls className="w-100 mt-1" style={{ height: '32px' }}>
                            <source src={`${FILE_BASE_URL}${langData.fazeelatAudio}`} />
                          </audio>
                        )}
                      </div>
                      <div className="mb-2">
                        <span className="small text-muted fw-bold">Reference (Hawala):</span>
                        <div className="text-dark small">{langData.reference || '—'}</div>
                      </div>
                      <div className="mb-2">
                        <span className="small text-muted fw-bold">Notes:</span>
                        <div className="text-dark small" style={{ whiteSpace: 'pre-wrap' }}>{langData.notes || '—'}</div>
                        {langData.notesAudio && (
                          <audio controls className="w-100 mt-1" style={{ height: '32px' }}>
                            <source src={`${FILE_BASE_URL}${langData.notesAudio}`} />
                          </audio>
                        )}
                      </div>
                      <div>
                        <span className="small text-muted fw-bold">Arabic Dua Script:</span>
                        <div
                          className="text-dark small font-arabic"
                          style={{ direction: 'rtl', whiteSpace: 'pre-wrap' }}
                        >
                          {langData.arabicScript || '—'}
                        </div>
                        {langData.arabicScriptAudio && (
                          <audio controls className="w-100 mt-1" style={{ height: '32px' }}>
                            <source src={`${FILE_BASE_URL}${langData.arabicScriptAudio}`} />
                          </audio>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Footer */}
        <div className="modal-footer bg-white border-top">
          <button type="button" className="btn btn-secondary px-4" onClick={() => setShowViewModal(false)}>Close</button>
          <button
            type="button"
            className="btn btn-primary px-4 d-flex align-items-center"
            onClick={() => { setShowViewModal(false); setShowModal(true); }}
          >
            <Pencil size={16} className="me-2" />Switch to Edit
          </button>
        </div>
      </div>
    </div>
  </div>
)}



{/* View modal */} 

{/* Separate View Modal */}
{/* Separate Folder View Modal */}
{showViewModalFolder && (
  <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.7)', zIndex: 1060 }}>
    <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
      <div className="modal-content border-0 shadow-lg">
        
        {/* Header */}
        <div className="modal-header bg-primary text-white py-3" style={{backgroundColor:' #747b26 !important'
        }}>
          <h5 className="modal-title fw-bold d-flex align-items-center">
            <i className="fas fa- eye me-2"></i> Folder Preview
          </h5>
          <button type="button" className="btn-close btn-close-white" onClick={() => setShowViewModalFolder(false)}></button>
        </div>

        {/* Body */}
        <div className="modal-body p-4 bg-light">
          
          {/* Section 1: Multilingual Folder Names */}
          <div className="row g-3 mb-4">
            <div className="col-md-4">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-body">
                  <label className="text-black small fw-bold text-uppercase">English Name</label>
                  <div className="fs-6 fw-bold text-black">{folderData.folder_name_english || '—'}</div>
                  <label className="text-muted small fw-bold text-uppercase d-block mt-2">Description</label>
                  <div className="small text-dark" style={{ whiteSpace: 'pre-wrap' }}>{folderData.folder_desc_english || '—'}</div>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-body">
                  <label className="text-black small fw-bold text-uppercase">Hindi Name</label>
                  <div className="fs-6 fw-bold text-black">{folderData.folder_name_hindi || '—'}</div>
                  <label className="text-muted small fw-bold text-uppercase d-block mt-2">Description</label>
                  <div className="small text-dark" style={{ whiteSpace: 'pre-wrap' }}>{folderData.folder_desc_hindi || '—'}</div>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-body">
                  <label className="text-black small fw-bold text-uppercase">Gujarati Name</label>
                  <div className="fs-6 fw-bold text-black">{folderData.folder_name_gujarati || '—'}</div>
                  <label className="text-muted small fw-bold text-uppercase d-block mt-2">Description</label>
                  <div className="small text-dark" style={{ whiteSpace: 'pre-wrap' }}>{folderData.folder_desc_gujarati || '—'}</div>
                </div>
              </div>
            </div>
          </div>

          <div className="row g-3 mb-4">
            <div className="col-md-4">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-body">
                  <label className="text-black small fw-bold text-uppercase">Transliteration</label>
                  <div className="fs-6 fw-bold text-black">{folderData.folder_name_transliteration || '—'}</div>
                  <label className="text-muted small fw-bold text-uppercase d-block mt-2">Description</label>
                  <div className="small text-dark" style={{ whiteSpace: 'pre-wrap' }}>{folderData.folder_desc_transliteration || '—'}</div>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card border-0 shadow-sm h-100 text-end">
                <div className="card-body">
                  <label className="text-black small fw-bold text-uppercase d-block">Arabic Name</label>
                  <div className="fs-4 font-arabic text-black" dir="rtl">{folderData.folder_name_arabi || '—'}</div>
                  <label className="text-muted small fw-bold text-uppercase d-block mt-2">Description</label>
                  <div className="small text-dark font-arabic" dir="rtl" style={{ whiteSpace: 'pre-wrap' }}>{folderData.folder_desc_arabi || '—'}</div>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card border-0 shadow-sm h-100 text-end">
                <div className="card-body">
                  <label className="text-black small fw-bold text-uppercase d-block">Urdu Name</label>
                  <div className="fs-4 font-arabic text-black" dir="rtl">{folderData.folder_name_urdu || '—'}</div>
                  <label className="text-muted small fw-bold text-uppercase d-block mt-2">Description</label>
                  <div className="small text-dark font-arabic" dir="rtl" style={{ whiteSpace: 'pre-wrap' }}>{folderData.folder_desc_urdu || '—'}</div>
                </div>
              </div>
            </div>
          </div>

          {/* Section 2: Selected Duas Summary */}
          <div className="card border-0 shadow-sm">
            <div className="card-header bg-white py-3 border-bottom">
              <h6 className="mb-0 fw-bold">
                Assigned Duas: <span className="text-muted">({folderData.dua_ids?.length || 0})</span>
              </h6>
            </div>
       <div className="card-body">
  {folderData.dua_names.length > 0 ? (
    <div className="d-flex flex-wrap gap-2">
      {folderData.dua_names.map((name, index) => (
        <span
          key={folderData.dua_ids[index]}
          className="badge bg-light text-dark border p-2"
        >
          <i className="fas fa-file-alt me-1 text-primary"></i>
          <span className="text-muted me-1" style={{ fontSize: '0.75em' }}>#{folderData.dua_ids[index]}</span>
          {name}
        </span>
      ))}
    </div>
  ) : (
    <div className="text-center py-3 text-muted">
      No Duas assigned to this folder.
    </div>
  )}
</div>
          </div>
        </div>
        {/* Footer */}
        <div className="modal-footer bg-white">
          <button type="button" className="btn btn-secondary px-4" onClick={() => setShowViewModalFolder(false)}>
            Close
          </button>
   
        </div>
      </div>
    </div>
  </div>
)}
              <style>{`
        :root {
          --deeniyat-green: #747b26;
          --deeniyat-gold: #b89c56;
          --bs-primary: var(--deeniyat-green);
          --bs-primary-rgb: 14, 95, 53;
        }
        .btn-primary { background-color: var(--deeniyat-green); border-color: var(--deeniyat-green); }
        .btn-primary:hover { background-color: #0a4728; border-color: #0a4728; }
        .btn-outline-primary { color: var(--deeniyat-green); border-color: var(--deeniyat-green); }
        .btn-outline-primary:hover { background-color: var(--deeniyat-green); color: white; }
        .text-primary { color: var(--deeniyat-green) !important; }
        .form-control:focus, .form-select:focus { border-color: var(--deeniyat-green); box-shadow: 0 0 0 0.25rem rgba(14, 95, 53, 0.25); }
        .nav-tabs .nav-link { color: #6c757d; border: none; border-bottom: 3px solid transparent; transition: all 0.3s ease; }
        .nav-tabs .nav-link:hover { color: #f0f0f0; border-color: transparent; }
        .nav-tabs .nav-link.active { color:  #f0f0f0; font-weight: bold; border-bottom: 3px solid var(--deeniyat-green); background-color: #f8f9fa; }
        .card-header-custom { background-color: white; border-bottom: 2px solid #f0f0f0; }
        .badge-deeniyat { background-color: var(--deeniyat-green); color: white; }
      `}</style>
           <style>
        {`
        
          }
          .btn-primary {
            background-color: #747b26;
            border-color: #747b26;
          }
          .btn-primary:hover {
            background-color: #747b26;
            border-color: #747b26;
          }
          .text-primary {
            color: var(--bs-primary) !important;
          }
          .bg-primary {
            background-color: var(--bs-primary) !important;
          }
          .brand-border-top {
            border-top: 4px solid var(--brand-gold);
          }
          .modal-header {
             border-bottom: 3px solid var(--brand-gold);
          }
        `}
      </style>
    </main>
  );
};

export default HifazatkiDua;
